'use client';

import { Modal } from '@paeffgen/react/crm-documents/ui';
import type { useReorderRequest } from './use-reorder-request';

interface ReorderChoiceDialogProps {
  reorder: ReturnType<typeof useReorderRequest>;
  onConfirmed?: () => void;
}

export function ReorderChoiceDialog({ reorder, onConfirmed }: ReorderChoiceDialogProps) {
  const { pending, confirm, cancel } = reorder;
  const count = pending?.items.length ?? 0;

  const handle = (mode: 'append' | 'replace') => {
    confirm(mode);
    onConfirmed?.();
  };

  return (
    <Modal
      isOpen={pending !== null}
      onClose={cancel}
      title="Anfrage übernehmen"
      className="max-w-md"
    >
      <div className="space-y-6">
        <p className="text-zinc-600">
          Sie haben bereits eine aktuelle Anfrage. Sollen die {count}{' '}
          {count === 1 ? 'Position' : 'Positionen'} dieser Anfrage hinzugefügt
          werden, oder die aktuelle Anfrage ersetzen?
        </p>
        <div className="flex flex-col gap-3">
          <button
            type="button"
            onClick={() => handle('append')}
            className="w-full px-4 py-3 bg-primary text-white rounded-lg font-bold hover:bg-primary-hover transition-colors"
          >
            Zur aktuellen Anfrage hinzufügen
          </button>
          <button
            type="button"
            onClick={() => handle('replace')}
            className="w-full px-4 py-3 border border-zinc-300 text-zinc-700 rounded-lg font-bold hover:bg-zinc-50 transition-colors"
          >
            Aktuelle Anfrage ersetzen
          </button>
          <button
            type="button"
            onClick={cancel}
            className="w-full px-4 py-2 text-sm font-medium text-zinc-500 hover:text-zinc-700 transition-colors"
          >
            Abbrechen
          </button>
        </div>
      </div>
    </Modal>
  );
}
